import React from 'react'
import LoaderButton from '../../components/LoaderButton'
import FormViewer from '../../components/FormViewer'
import { checkTranslation, chooseWallpaper, conditionalWidth, translate } from "../../utils/useful";
import Responsive from '../../components/Responsive';
import BottomSheet from '../../components/BottomSheet';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';
import HttpServices from '../../utils/Http.services';
import Modal from '../../components/Modal';


class CASelectType extends React.Component {
    state = {


        financeHeaders: [
            { key: 'relatedApplet', type: 'SelectInput', information: { address: 'getMyAppletsType', filter: { features: 'Finance' }, fields: { title: 'applet.name', value: 'applet._id' }, type: 'api', isSearchable: true, required: true, } },
        ]
        // appletCategories: [
        //     { name: 'Business' },
        //     { name: 'IT and tech' },
        //     { name: 'Human resources' },
        //     { name: 'Productivity' },

        // ]
    }

    componentDidMount() {
        this.props.showHeader(true, () => {
            if (this.props.setHeader) {
                this.props.setHeader({
                    // 'toolbar': null,
                    // 'showToolbar': false,
                    'title': translate('ca.Create Applet'),
                    isPortal: true, doNotshowNotification: true,
                    showSettings: false,
                    create: true,
                    // 'info': translate('Create Applet') + " | " + translate('Choose Type'),
                    // topHeaderComponent: this.topHeaderComponent,
                    // headerIdentityComponent: this.headerIdentityComponent,
                    backAction: () => this.props.lastStage()
                })
            }
        })
    }

    componentWillUnmount() {
    }

    openApplet = (item) => {

        this.bottomSheet.open()
        this.setState({ currentItem: item })
    }
    passApplet = () => {
        let data = {}
        let formData = this.financeForm.getForm()
        data.appletType = this.state.currentItem
        data.appletType = { ...data.appletType, ...formData ?? {} }
        data.features = this.state.currentItem?.features


        // if (formData && Object.keys(formData).length > 0) {

            this.props.setData(data, () => {

                this.props.setCurrentAppletTemplate(this.state.currentItem, () => {
                    this.props.continue(this.props.stageName)
                })
            })
        // }
    }
    confirmApplet = () => {
        let data = { appletType: this.state.currentItem }
        data.features = this.state.currentItem?.features

        console.log(data)
        if (data.features.includes('Commerce')) {
            HttpServices.request('getMyAppletsType', { frameType: 'Finance' }, (fetchResult, fetchError) => {
               
               console.log(fetchResult,fetchError)
                if (fetchError) {
                    return
                }

                let financeList = fetchResult.info?.length != 0 ? true : false
                this.setState({ financeList })
                this.commerceModal.open()
            })
        } else {

            if (data) {
                data.collectionInfo = {}
                this.props.setData(data, () => {
                    this.props.setCurrentAppletTemplate(this.state.currentItem, () => {
                        this.props.continue(this.props.stageName)
                    })
                    // let step = this.state.currentItem.steps[0] ?? 'info'
                    // this.props.changeStage(step)
                })
            }
        }
    }





    render() {
        return (

            <div className="scroll-no-scrollbar w-100 h-100 window-content-radius" style={{}}>
                {/* <div className='w-100 h-100'> */}

                {/* <div className='w-100 position-relative' style={{ zIndex: 0, overflow: 'hidden', position: "sticky", top: 0 }}> */}
                {/* <div className='w-100 window-content-radius-top' style={{ background: (this.props.bgColor), padding: "12px 15px", height: 52 }}>
                    <div className='flexc'>
                        <div onClick={() => this.props.lastStage()} className='flexcc'>
                            <img className='rtl-button' src="/assets/icons/back-white.svg" height={28} />
                        </div>
                        <div className='px-2 flexcc' style={{}}>
                            <h2 className="cursor-pointer text-normal text-semibold white " >{translate('ca.Create Applet')}</h2>
                        </div>
                    </div>
                </div> */}


                {/* <div>
                            <div style={{ height: 500, width: 500, zIndex: 0, position: 'absolute', top: -50, left: -50, background: 'radial-gradient(67.22% 50% at 50% 39%, rgba(51, 231, 255, 0.15) -84%, rgba(245, 228, 255, 0) 100%)' }}> </div>

                            <div style={{ height: 500, width: 500, zIndex: 0, position: 'absolute', top: -100, left: "50%", background: 'radial-gradient(48.02% 35.72% at 50% 50%, rgba(255, 247, 51, 0.15) 0%, rgba(128, 255, 0, 0) 100%)' }}></div>
                        </div> */}
                {/* </div> */}


                <div className='w-100' style={{ background: '#fff', }}>
                    <div className=' w-100 ' style={{ background: '#fff' }}>
                        <div className='flexc px-5 pt-3' style={{}}>
                            <div className={'bg-white br-20 py-2 px-3 mt-2 box-shadow-20 flexcb w-100'} style={{ maxWidth: 400, boxShadow: "0px 3px 20px rgb(16 16 16 / 6%)", border: "1px solid #f3f3f3" }}>
                                <input className='transparent-input w-100 text-small' placeholder={translate("ca.What are you looking for?")} />
                                <div className='opacity-5 flexcc'>
                                    <img src='/assets/icons/useful/magnifying.png' height={20} />
                                </div>
                            </div>
                        </div>

                        <div className='px-5 pt-4' style={{}}>
                            <h2 className=" text-semibig mb-0 color-dark-blue-1" >{translate('ca.Base Applets')}</h2>
                            <p className="mt-1 text-small color-dark-blue-1 max-width-500" >{translate("ca.start-with-base-applet")}</p>
                        </div>

                        <div className='px-5 mt-3 d-flex w-100 flex-wrap'>
                            {this.props.baseApplets.map((item, index) => {
                                return (

                                    <Responsive width={this.props.width} media={{ xs: '6', sm: '3', lg: "3", xl: "2" }} key={index}>

                                        <button onClick={() => this.openApplet(item)} className='text-start color-dark-blue-1 mb-4 prd-4'>
                                            <div className=' flexc'>
                                                <img src={item.icon} height={40} />
                                            </div>
                                            <p className='text-start text-small text-bold mt-2'>{checkTranslation(item.name)}</p>
                                            <p className='text-start text-smaller mt-0'>{checkTranslation(item.description)}</p>

                                        </button>

                                    </Responsive>
                                )
                            })}
                        </div>
                    </div>



                    <div className=' w-100 mt-3 window-content-radius' style={{ background: '#f2f6f8', borderRadius: '20px 20px 0px 0px' }}>
                        <div className='px-5 pt-4' style={{ borderRadius: 8, flex: 1 }}>
                            <h2 className=" text-semibig mb-0 color-dark-blue-1" ><span className='text-small'>{translate('ca.or')}</span> {translate('ca.Explore Applets World')}</h2>
                            {/* <p className="mt-1 text-small color-dark-blue-1 max-width-500" >{translate("You can start with a base applet. You can later combine base applet's features with other features")}</p> */}
                        </div>

                        <div className='px-5 mt-3 d-flex w-100 flex-wrap'>
                            {this.props.baseApplets.map((item, index) => {
                                return (

                                    <Responsive width={this.props.width} media={{ xs: '12', md: '6', lg: "6", xl: "4" }} key={index}>

                                        <button onClick={() => this.openApplet(item)} className={'text-start color-dark-blue-1 mb-3 bg-white br-10 px-3 pt-3 pb-2 ' + (conditionalWidth(this.props.width, { xs: 'w-100', md: 'w-95' }))}>
                                            <div className='d-flex'>
                                                <div className='d-flex pt-1'>
                                                    <img src={item.icon} height={40} />
                                                </div>
                                                <div className='pld-3'>
                                                    <p className='text-small text-bold '>{checkTranslation(item.name)}</p>
                                                    <p className='text-smaller mt-0'>{checkTranslation(item.description)}</p>
                                                    <p className='text-smaller mt-1 opacity-5'>{translate("ca.View More")}</p>

                                                </div>
                                            </div>
                                        </button>

                                    </Responsive>
                                )
                            })}
                        </div>
                    </div>
                </div>



                {/* </div> */}


                <BottomSheet ref={el => this.bottomSheet = el} width={this.props.width}>
                    <div>
                        <div className='bg-gray-1  pt-3' style={{ marginTop: -20 }}>
                            <div className='px-4 flexcb'>
                                <div className='flexc'>
                                    <img src={this.state.currentItem?.icon} height={40} />
                                    <div className='mx-3'>
                                        <p className="text-bold text-normal mb-0 color-dark-blue-1" >{checkTranslation(this.state.currentItem?.name)}</p>
                                        <div style={{ maxWidth: 450 }}>
                                            <p className="mt-0 text-small color-dark-blue-1" >{translate('ca.Select the applet they you want to continue with')}</p>
                                        </div>
                                    </div>
                                </div>

                                {/* <LoaderButton
                                    onClick={() => this.confirmApplet()}
                                    isLoading={this.state.isLoading}
                                    text={translate("ca.Continue")}
                                    // background='linear-gradient(to right, #0796A9, #3391FF)'
                                    // background='linear-gradient(to right, #0094FF, #6100FF)'
                                    icon={'/assets/icons/angle-right-white2.svg'}
                                    backgroundImage='linear-gradient(45deg, #009a90 0%, #208aee 51%, #007aff  100%)'
                                    className={'button-interactive-1'}
                                    language={this.props.language}
                                /> */}
                                <ButtonAnimated
                                    onClick={() => this.confirmApplet()}
                                    title={translate("ca.Continue")}
                                    icon={'/assets/icons/angle-right-white2.svg'}
                                    imgWidth={'25px'}
                                    bg='linear-gradient(45deg, rgb(97, 0, 255) 51%, rgb(0, 148, 255) 100%)'
                                    textColor='#fff'
                                    language={this.props.language}
                                />

                            </div>

                            <div className='px-4 mt-3 '>
                                <button className='color-blue-1 text-normal mrd-4 pb-2' style={{ borderBottom: '1px solid #1379FF' }}><p className='text-small'>{translate('ca.Details')}</p></button>
                                <button className='color-dark-blue-1 text-normal mrd-4 pb-2' style={{ borderBottom: '1px solid transparent' }}><p className='text-small'>{translate('ca.Reviews')}</p></button>
                                <button className='color-dark-blue-1 text-normal mrd-4 pb-2' style={{ borderBottom: '1px solid transparent' }}><p className='text-small'>{translate('ca.Technical')}</p></button>


                            </div>
                        </div>
                        <div className='px-4 d-flex flex-wrap pt-4'>
                            <Responsive width={this.props.width} media={{ xs: '12', md: '8', lg: "8", xl: "8" }} >
                                <div className={'' + (conditionalWidth(this.props.width, { xs: 'prd-0', md: 'prd-4' }))}>
                                    <p className='text-normal text-bold mb-2'>{translate('ca.Description')}</p>
                                    <p className='text-small '>{translate('Lorem ipsum, dolor sit amet consectetur adipisicing elit. Laboriosam, alias ratione. Repellat, voluptatibus doloribus adipisci, a ipsam dicta maiores impedit temporibus voluptas harum necessitatibus eum quasi? Assumenda illum dicta sint!')}</p>
                                </div>
                            </Responsive>

                            <Responsive width={this.props.width} media={{ xs: '12', md: '4', lg: "4", xl: "4" }} >
                                <div className={'bb-1 pb-2 mb-2 flexcb ' + (conditionalWidth(this.props.width, { xs: 'mt-4', md: 'mt-0' }))}>
                                    <p className='text-small'>{translate("ca.Created By")} </p>
                                    <p className='text-bold text-small'>{translate('ca.Yonnect team')}</p>
                                </div>

                                <div className='bb-1 pb-2 mb-2 flexcb'>
                                    <p className='text-small'>{translate("ca.Tags")} </p>
                                    <p className='text-smaller tag-style px-2 py-1'>{translate('ca.University')}</p>
                                </div>

                            </Responsive>

                        </div>

                    </div>
                </BottomSheet>
                <Modal ref={el => this.commerceModal = el} maxWidth={400}>
                    <div className='flexcc flex-column p-3 bg-white br-15'>
                        {(this.state.financeList && this.state.financeList.length != 0) ? (
                            <div className='w-100'>
                                <div className='px-2 mb-3'>
                                    <p className='text-semibold'>{translate("select finance module")}</p>
                                    <p className=' text-small'>{translate("Any commerce module needs to be connected to a financial module.")}</p>
                                </div>
                                <FormViewer ref={el => this.financeForm = el} initData={this.props.initData?.relatedApplet} headers={this.state.financeHeaders} formClass="modern" inputClass={'modern-input'} nopadding={true} />
                                <button onClick={() => this.passApplet()}>
                                    <div className='px-4 py-2 br-20' style={{ backgroundColor: '#5856d6', color: '#fff' }}>
                                        <p>{translate("Continue")}</p>
                                    </div>
                                </button>
                            </div>
                        ) : (
                            <div>
                                you should create finance applet first
                            </div>

                        )}
                    </div>
                </Modal>

            </div>

        )
    }
}

export default CASelectType;